import {
  ITrackingDTO,
  TrackingExternalStatusEnum,
  TrackingStatusEnum,
} from "@hooks/dtos/ITrackingDTO";
import { config } from "config";
import dayjs from "dayjs";
import { FaExclamationTriangle, FaWhatsapp } from "react-icons/fa";

interface IProps {
  tracking: ITrackingDTO;
  isInSEFAZ: boolean;
  alreadyInSEFAZ: boolean;
  tryDelivery: boolean;
}

export const TrackingStatusMessage = ({
  tracking,
  isInSEFAZ,
  alreadyInSEFAZ,
  tryDelivery,
}: IProps) => {
  return (
    <>
      {tracking.externalStatus === TrackingExternalStatusEnum.CREATED ||
      tracking.externalStatus === TrackingExternalStatusEnum.ENTREGUE ? (
        <>
          {/* Status FINISHED */}
          {tracking.status === TrackingStatusEnum.FINISHED && (
            <>
              <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                Pedido Entregue
              </div>
              <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                <div
                  className="d-flex flex-column fw-bold"
                  style={{ fontSize: "24px" }}
                >
                  {tracking?.deliveryForecast ? (
                    dayjs(tracking.deliveryForecast).format("DD/MM/YYYY")
                  ) : (
                    <span className="fs-5">Previsão Indisponível</span>
                  )}
                </div>
              </div>
            </>
          )}

          {/* Status NOT FINISHED */}
          {tracking.status !== TrackingStatusEnum.FINISHED && (
            <>
              {/* Case: isInSEFAZ */}
              {isInSEFAZ && (
                <>
                  <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                    Previsão Indisponível
                  </div>
                  <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                    <div
                      className="d-flex flex-column fw-bold"
                      style={{ fontSize: "24px" }}
                    >
                      <span className="fs-5">Em análise na SEFAZ</span>
                    </div>
                  </div>
                </>
              )}

              {/* Case: alreadyInSEFAZ */}
              {!isInSEFAZ && alreadyInSEFAZ && (
                <>
                  <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                    Pedido em Percurso
                  </div>
                  <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                    <div
                      className="d-flex flex-column fw-bold"
                      style={{
                        fontSize: tracking.deliveryForecast ? "24px" : "20px",
                      }}
                    >
                      {tracking.deliveryForecast
                        ? dayjs(tracking.deliveryForecast).format("DD/MM/YYYY")
                        : "Previsão sendo estimada"}
                      <small className="fw-normal">Data Prevista</small>
                    </div>
                  </div>
                </>
              )}

              {/* Case: Default */}
              {!isInSEFAZ && !alreadyInSEFAZ && (
                <>
                  <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                    Previsão de Entrega
                  </div>
                  <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                    <div
                      className="d-flex flex-column fw-bold"
                      style={{ fontSize: "24px" }}
                    >
                      {tryDelivery ? (
                        <span style={{ fontSize: "1.2rem" }}>
                          Nova tentativa no próx. dia útil.
                        </span>
                      ) : (
                        <>
                          {tracking?.deliveryForecast ? (
                            dayjs(tracking.deliveryForecast).format(
                              "DD/MM/YYYY",
                            )
                          ) : (
                            <span className="fs-5">Previsão Indisponível</span>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <>
          {/* External Status: AGUARDANDO_CONCILIACAO */}
          {tracking.externalStatus ===
          TrackingExternalStatusEnum.AGUARDANDO_CONCILIACAO ? (
            <>
              <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                Aguardando Conciliação
              </div>
              <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                <div
                  className="d-flex flex-column fw-bold"
                  style={{ fontSize: "1.2rem" }}
                >
                  Seu pedido está aguardando conciliação financeira.
                </div>
              </div>
            </>
          ) : (
            <>
              {/* External Status: Other (Pendência de Validação) */}
              <div className="d-flex align-items-center justify-content-center mb-2">
                <FaExclamationTriangle className="fs-5 text-warning me-2" />{" "}
                <span>Pendência de Validação</span>
              </div>
              <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                <div
                  className="d-flex flex-column fw-bold"
                  style={{ fontSize: "1.1rem" }}
                >
                  Estamos atualizando as informações de acordo com a exigência,
                  em caso de dúvidas, entre em contato com o atendimento.
                  {(() => {
                    const message = `Olá, preciso de ajuda com meu pedido.
                      Status atual: Pendência de Validação
                      Número do pedido: ${tracking.code}  
                      Data: ${dayjs(tracking.createdAt).format("DD/MM/YYYY")}
                      Poderia me auxiliar?`;

                    return (
                      <a
                        href={`https://wa.me/55${config.contact.whatsapp}?text=${encodeURIComponent(message)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        // className="btn btn-outline-primary py-0 px-2 ms-2 mt-2"
                        className="mt-2"
                        aria-label="WhatsApp"
                      >
                        <FaWhatsapp className="text-success me-1" size={24} />
                        <span className="text-muted">Atendimento</span>
                      </a>
                    );
                  })()}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};
